(() => {
  const message = input => {
    const validity = input.validity;
    if (validity.valueMissing) return input.type === 'checkbox' ? 'Acepta esta opción para continuar.' : 'Completa este campo.';
    if (validity.typeMismatch && input.type === 'email') return 'Ingresa un correo electrónico válido.';
    if (validity.rangeUnderflow) return `El valor mínimo es ${input.min}.`;
    if (validity.rangeOverflow) return `El valor máximo es ${input.max}.`;
    if (validity.stepMismatch) return 'Selecciona una cantidad válida.';
    if (validity.patternMismatch) return 'Revisa el formato de este campo.';
    return '';
  };
  document.addEventListener('invalid', event => {
    const input = event.target;
    if (typeof input.setCustomValidity !== 'function' || input.validity.customError) return;
    input.setCustomValidity(message(input));
    if (input.validity.customError) input.dataset.vrSpanishValidity = 'true';
  }, true);
  const clear = event => {
    if (event.target.dataset.vrSpanishValidity) {
      event.target.setCustomValidity('');
      delete event.target.dataset.vrSpanishValidity;
    }
  };
  document.addEventListener('input', clear);
  document.addEventListener('change', clear);
})();
